import { render, staticRenderFns } from "./SelectBoxTempNoFilter.vue?vue&type=template&id=2dda1a2f&"
import script from "./SelectBoxTempNoFilter.vue?vue&type=script&lang=js&"
export * from "./SelectBoxTempNoFilter.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxTempNoFilter.vue?vue&type=style&index=0&id=2dda1a2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports